import { useQuery } from '@tanstack/react-query'
import { useSearch } from '@tanstack/react-router'

import { clientPortalEoirPublicCaseInformationQuery } from '@/lib/queries/case-dashboard/eoir/queries'

import { useClientPortalEoirPublicUrlParams } from './use-client-portal-eoir-public-url-params'

export const useClientPortalEoirPublicData = () => {
  const { caseId } = useClientPortalEoirPublicUrlParams()
  const { companyId } = useSearch({
    from: '/client-portal/eoir/public/$encodedCaseId',
  })
  const { data: dataClientPortalEoirPublic } = useQuery(
    clientPortalEoirPublicCaseInformationQuery({
      caseId: Number(caseId),
      companyId,
    })
  )

  const caseNumber = dataClientPortalEoirPublic?.caseInformation.alienNumber
  const dataProUserSelectedCases = dataClientPortalEoirPublic?.relevantCase

  return {
    caseId: Number(caseId),
    caseNumber,
    companyId,
    dataClientPortalEoirPublic,
    dataProUserSelectedCases,
  }
}
